import { Paperclip } from 'lucide-react';
import { DeliveryStatusBadge } from '@/components/email/DeliveryStatusBadge';
import { formatDate, formatReferenceType } from '@/utils/formatters';
import type { InvestorEmailLogItem } from '@/types/investorEmail';

interface EmailRowProps {
  email: InvestorEmailLogItem;
  onClick: (emailId: string) => void;
}

export function EmailRow({ email, onClick }: EmailRowProps) {
  return (
    <button
      type="button"
      onClick={() => onClick(email.email_queue_id)}
      className="flex w-full items-center justify-between gap-4 border-b border-border px-4 py-3 text-left transition-colors hover:bg-muted/50"
    >
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h3 className="truncate font-medium text-foreground">
            {email.subject}
          </h3>
          <DeliveryStatusBadge
            status={email.delivery_status}
            className="flex-shrink-0"
          />
          {email.has_attachments && (
            <Paperclip
              className="h-3.5 w-3.5 flex-shrink-0 text-muted-foreground"
              aria-label="Has attachments"
            />
          )}
        </div>
        <p className="mt-0.5 truncate text-sm text-muted-foreground">
          {formatReferenceType(email.type)} · To: {email.to_email}
        </p>
      </div>
      <div className="flex-shrink-0 text-xs text-muted-foreground">
        {formatDate(email.date)}
      </div>
    </button>
  );
}
